import React from 'react';
import heroPhoto from '../../assets/images/photos/hero-equipo.jpg';
import './HeroSection.css';

const HeroSection = () => {
  const handleScrollTo = (e, targetId) => {
    e.preventDefault();
    const targetEl = document.querySelector(targetId);
    if (targetEl) {
      const headerOffset = 70;
      const elementPosition = targetEl.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="df-hero-section" id="top">
      <div className="df-hero-container">
        {/* Contenido Textual (Izquierda) */}
        <div className="df-hero-content">
          <h1 className="df-hero-title">
            <strong>Digital Factura</strong> Proveedor Autorizado de Certificación (PAC) por el SAT
          </h1>

          <p className="df-hero-subtitle">
            Plataforma para la administración de negocios, facturación electrónica y fábrica de software personalizado para ti.
          </p>

          <div className="df-hero-actions">
            <a
              href="#timbrado"
              className="df-hero-btn-primary"
              onClick={(e) => handleScrollTo(e, '#timbrado')}
            >
              Conoce nuestras soluciones
            </a>

            <a
              href="#contacto"
              className="df-hero-link-asesor"
              onClick={(e) => handleScrollTo(e, '#contacto')}
            >
              Contacta con un asesor
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M5 12h14M13 6l6 6-6 6"></path>
              </svg>
            </a>
          </div>
        </div>

        {/* Visual Decorativo Original (Derecha) */}
        <div className="df-hero-visual-wrapper">
          <div className="df-hero-composition">
            {/* Círculo 1: Fondo suave tenue */}
            <div className="df-hero-circle-tint" aria-hidden="true"></div>

            {/* Círculo 2: Anillo decorativo rojo con corte geométrico */}
            <div className="df-hero-circle-ring" aria-hidden="true"></div>

            {/* Fotografía del Equipo con arco redondeado */}
            <img
              src={heroPhoto}
              alt="Equipo profesional de Digital Factura sonriendo"
              className="df-hero-team-photo"
              loading="eager"
            />


            {/* Badge flotante inferior izquierdo: Métrica de Timbrado */}
            <div className="df-hero-stat-badge">
              <span className="df-hero-stat-label">Tiempo por timbre</span>
              <span className="df-hero-stat-value">70-100 ms</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
